import { connect } from 'react-redux';

import {
  getSafeMetric,
  getPrecision,
  getCompare,
} from '../../selectors/options';
import {
  getTotalTimespanInterval,
  getTotalCompareInterval,
} from '../../selectors/intervals';
import { getCrimeTypeText } from '../../selectors/crimes';
import {
  getTotalLocationsCount,
  getSelectedCityName,
} from '../../selectors/locations';
import { isCensusView } from '../../selectors/router';
import CrimeCount from './CrimeCount';

const TotalCrimeCount = connect(state => ({
  censusView: isCensusView(state),
  city: getSelectedCityName(state),
  metric: getSafeMetric(state),
  crimeTypeText: getCrimeTypeText(state),
  locationsCount: getTotalLocationsCount(state),
  precision: getPrecision(state),
  compare: getCompare(state),
  timespanInterval: getTotalTimespanInterval(state),
  compareInterval: getTotalCompareInterval(state),
}))(CrimeCount);

TotalCrimeCount.displayName = 'TotalCrimeCount';

export default TotalCrimeCount;



// WEBPACK FOOTER //
// ./src/components/CrimeCount/TotalCrimeCount.jsx